
$(document).ready(function () {
    $('.counter').countUp();

    $(".maptbList a").click(function (event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".mapcont").not(tab).css("display", "none");

        $('.map-link').removeClass("active");
        $(this).addClass("active");

        $(tab).fadeIn();
    });
});

